import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-70e8228b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionSubmitView" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";
import {
  QuestionControllerService,
  QuestionSubmitQueryRequest,
} from "../../../backend/question";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSubmitView',
  setup(__props) {

const tableRef = ref();
const dataList = ref([]);
const total = ref(0);
// 搜索请求
const searchParams = ref<QuestionSubmitQueryRequest>({
  questionId: undefined,
  submitLanguage: undefined,
  pageSize: 10,
  current: 1,
});

const colors = ["orange", "green", "blue", "red"];

const loadData = async () => {
  const res = await QuestionControllerService.listQuestionSubmitUsingPost({
    ...searchParams.value,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败," + res.message);
  }
};
/**
 * 监听 searchParams 变量，改变时重新加载页面
 */
watchEffect(() => {
  loadData();
});

/**
 * 页面加载时，请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  // {
  //   title: "提交号",
  //   dataIndex: "id",
  //   align: "center",
  // },
  {
    title: "题号",
    slotName: "questionId",
    align: "center",
  },
  {
    title: "提交者",
    dataIndex: "userId",
    align: "center",
  },
  {
    title: "判题信息",
    slotName: "judgeInfo",
    align: "center",
  },
  {
    title: "编程语言",
    dataIndex: "language",
    align: "center",
  },
  {
    title: "提交状态",
    slotName: "status",
    align: "center",
  },

  {
    title: "创建时间",
    slotName: "createTime",
    align: "center",
  },
];

/**
 * 当前分页
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 分页大小
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

/**
 * 跳转到做题页面
 */
const router = useRouter();
const toQuestionPage = (question: QuestionSubmitQueryRequest) => {
  router.push({
    path: `/view/question/${question.questionId}`,
  });
};

/**
 * 搜索函数
 */
const doSubmit = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
  // loadData();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"margin-left":"300px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "questionId",
          label: "题号",
          tooltip: "请输入题目Id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.questionId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.questionId) = $event)),
              placeholder: "请输入搜索题号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "language",
          label: "编程语言：",
          style: {"min-width":"240px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: searchParams.value.submitLanguage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.submitLanguage) = $event)),
              placeholder: "选择编程语言"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("java")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("cpp")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("csharp")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("go")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("python")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "round",
              status: "normal",
              type: "outline",
              onClick: doSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "round",
              status: "success",
              type: "primary",
              onClick: loadData
            }, {
              default: _withCtx(() => [
                _createTextVNode("刷新 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_divider, { size: "0" }),
    _createVNode(_component_a_table, {
      ref: tableRef.value,
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showJumper: true,
        showPageSize: true,
      },
      "column-resizable": "",
      wrapper: "",
      onPageSizeChange: onPageSizeChange,
      onPageChange: onPageChange
    }, {
      judgeInfo: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.judgeInfo, (info, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: colors[index.length % colors.length],
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${
                index === "message"
                  ? "结果"
                  : index === "time"
                  ? "耗时"
                  : "消耗内存"
              }`) + " " + _toDisplayString("：" + info), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      questionId: _withCtx(({ record }) => [
        _createVNode(_component_a_link, {
          status: "success",
          style: {"color":"blue"},
          onClick: ($event: any) => (toQuestionPage(record))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.questionId), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      status: _withCtx(({ record }) => [
        (record.status === 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "cyan"
            }, {
              default: _withCtx(() => [
                _createTextVNode("待判题")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 1)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode("判题中")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 2)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              color: "blue"
            }, {
              default: _withCtx(() => [
                _createTextVNode("成功")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.status === 3)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              color: "red"
            }, {
              default: _withCtx(() => [
                _createTextVNode("失败")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})